/**
 * Pages people can open, but that should not compete with marketing landings
 * in search. Same list as santa-frontend, plus /ui-kit.
 *
 * Keep these crawlable (do not Disallow in robots.txt) so bots see noindex.
 */

export const ROBOTS_NOINDEX_CONTENT = 'noindex, follow';

const NOINDEX_EXACT_PATHS = [
  '/admin',
  '/premium/buy',
  '/open',
  '/open/recover',
  '/login',
  '/register',
  '/recover',
  '/recover_deactivated',
  '/reset_password',
  '/resend',
  '/box/new',
  '/policy',
  '/terms',
  '/privacy_policy',
  '/account',
  '/box',
  '/version',
  '/ui-kit',
];

export function shouldNoIndex(pathname: string): boolean {
  return (
    NOINDEX_EXACT_PATHS.includes(pathname) ||
    pathname.startsWith('/admin/') ||
    pathname.startsWith('/premium/buy/') ||
    pathname.startsWith('/account/') ||
    pathname.startsWith('/box/') ||
    pathname.startsWith('/randomizer/')
  );
}
